import { useI18n } from "@/i18n/I18nContext";
import { TextPageLayout } from "@/pages/components/TextPageLayout";
import { DocumentHead } from "@/seo/DocumentHead";

export function AdvertisingPage() {
  const { messages } = useI18n();
  const a = messages.advertising;

  return (
    <TextPageLayout title={a.pageTitle}>
      <DocumentHead
        title={a.seoTitle}
        description={a.seoDescription}
        path="/advertising"
      />
      <h2 className="mb-4 text-3xl text-[#111111]">{a.approach.title}</h2>
      <p className="mb-6 text-gray-700">{a.approach.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{a.noAds.title}</h2>
      <p className="mb-6 text-gray-700">{a.noAds.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{a.noDataSelling.title}</h2>
      <p className="mb-6 text-gray-700">{a.noDataSelling.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{a.noTracking.title}</h2>
      <p className="mb-6 text-gray-700">{a.noTracking.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{a.sustainability.title}</h2>
      <p className="mb-4 text-gray-700">{a.sustainability.body}</p>
      <ul className="mb-6 list-disc space-y-2 pl-6 text-gray-700">
        {a.sustainability.items.map((item) => (
          <li key={item.label}>
            <strong>{item.label}</strong> {item.text}
          </li>
        ))}
      </ul>

      <h2 className="mb-4 text-3xl text-[#111111]">{a.noAffiliate.title}</h2>
      <p className="mb-6 text-gray-700">{a.noAffiliate.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{a.noPromotions.title}</h2>
      <p className="mb-6 text-gray-700">{a.noPromotions.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{a.partnerships.title}</h2>
      <p className="mb-6 text-gray-700">{a.partnerships.body}</p>

      <h2 className="mb-4 text-3xl text-[#111111]">{a.future.title}</h2>
      <p className="mb-4 text-gray-700">{a.future.body}</p>
      <ul className="mb-6 list-disc space-y-2 pl-6 text-gray-700">
        {a.future.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <h2 className="mb-4 text-3xl text-[#111111]">{a.supporting.title}</h2>
      <p className="mb-4 text-gray-700">{a.supporting.body}</p>
      <ul className="mb-6 list-disc space-y-2 pl-6 text-gray-700">
        {a.supporting.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>

      <div className="mt-12 rounded-3xl bg-gradient-to-br from-[#4CAF50] to-[#45a049] p-8 text-white">
        <h3 className="mb-3 text-2xl">{a.cta.heading}</h3>
        <p className="mb-6">{a.cta.body}</p>
        <a
          href="mailto:hello@wasok.app"
          className="inline-block rounded-xl bg-white px-8 py-3 text-[#4CAF50] transition-colors duration-200 hover:bg-gray-100"
        >
          {a.cta.button}
        </a>
      </div>
    </TextPageLayout>
  );
}
